import { $body, hbToggle, initMainImagePopup } from './utils';
import $ from 'jquery';
import 'sticky-kit/dist/sticky-kit';
import 'magnific-popup';
declare const Drupal;

const ALPHA_PATTERN = /[a-z]/i;
const STICKY_NAV_CLASS = 'sticky-nav';
const HALF_SECOND = 500;
const STICKY_KIT_RECALC = 'sticky_kit:recalc';
const CLICK = 'click';
const OPEN = 'open';
const SHOW = 'show';

$(() => {
  const stickyKitRecalculator = (): {
    startStickyRecalc(): void;
    stopStickyRecalc(): void;
  } => {
    /**
     * Start and stop sticky recalc interval.
     * This is used in conjunction with expandable content
     * to make sure the sticky elements get updated correctly
     */
    let stickyRecalc;
    function startStickyRecalc(): void {
      if (stickyRecalc) {
        cancelAnimationFrame(stickyRecalc);
      }
      stickyRecalc = requestAnimationFrame((): void => {
        $body.trigger(STICKY_KIT_RECALC);
        startStickyRecalc();
      });
    }

    function stopStickyRecalc(): void {
      cancelAnimationFrame(stickyRecalc);
    }

    return {
      startStickyRecalc,
      stopStickyRecalc,
    };
  };

  const { startStickyRecalc, stopStickyRecalc } = stickyKitRecalculator();

  /**
   * Prep main nav
   */
  function prepNav(): void {
    // Set main nav to absolute positioned and set header padding based on height in order
    // to make a nice sticky transition for JS enabled browsers
    const header = $('#app-header');
    const nav = $('#app-navigation-container');
    const navHeight = nav.outerHeight();

    nav.css('position', 'absolute');
    header.css('padding-bottom', navHeight);
  }

  /**
   * Toggle sticky main nav
   */
  function stickyNav(): void {
    const nav = $('#app-navigation');

    const scrollTop = $(window).scrollTop();
    const scrollBreak = $('#app-header').height();

    if (scrollTop > scrollBreak && !nav.hasClass(STICKY_NAV_CLASS)) {
      // Add sticky
      nav.addClass(STICKY_NAV_CLASS);
    } else if (scrollTop < scrollBreak && nav.hasClass(STICKY_NAV_CLASS)) {
      // Remove sticky
      nav.removeClass(STICKY_NAV_CLASS);
    }
  }

  /**
   * Primary menu switch between mobile and normal menu
   */
  function menuModeSwitch(): void {
    const $appNavigation = $('#app-navigation');
    if ($appNavigation.hasClass(OPEN)) {
      $appNavigation.removeClass(OPEN);
    }

    // Vars
    const app = $('#app');
    const navContainer = $('#app-navigation-inner');
    const navSearch = $('#app-search');
    let navItemsWidth = 0;
    const totalSpace = navContainer.width() - navSearch.width();
    const extraSpace = 50;

    // Get width of all primary menu items.
    $('#main-navigation-wrap .menu-level-1 > ul > li > a > .menu-item--link-inner').each(function (): void {
      navItemsWidth += $(this).outerWidth(true);
    });

    const totalWidth = navItemsWidth + extraSpace;

    if (totalWidth > totalSpace && !app.hasClass('mobile-menu')) {
      // Switch to MOBILE
      app.addClass('mobile-menu');
    } else if (totalWidth < totalSpace && app.hasClass('mobile-menu')) {
      // Switch to NORMAL
      app.removeClass('mobile-menu');
    }
  }

  /**
   * Primary menu show/hide submenu on hover if not mobile nav
   */
  function primaryNavHover(): void {
    // Primary nav level 1 items with children
    const hoverItems = $('#main-navigation-wrap .menu-level-1 > ul > .menu-item--has-children');

    // To avoid scenarios with multiple binds, lets remove all hover bindings before we start.
    hoverItems.off('mouseenter mouseleave');
    if (!$('#app').hasClass('mobile-menu')) {
      // NORMAL
      let timer;
      hoverItems
        .on('mouseenter', function onMainMenuMouseEnter() {
          const that = $(this);
          timer = setTimeout(function () {
            const subHeight = $('> .sub-menu', that).outerHeight();
            // Show
            $('> .sub-menu', that).css('bottom', -subHeight);
          }, HALF_SECOND);
        })
        .on('mouseleave', function onMainMenuMouseLeave() {
          clearTimeout(timer);
          // Hide
          $('> .sub-menu', hoverItems).removeAttr('style');
        });
    }
  }

  /**
   * Primary menu show/hide mobile menu
   */
  function toggleMobileNav(): void {
    const mainNav = $('#app-navigation');
    const scrollTo = $('#app-header').height() - 3;

    if (mainNav.hasClass(OPEN)) {
      mainNav.removeClass(OPEN);
      $('html, body').animate({ scrollTop: scrollTo }, HALF_SECOND, function () {
        mainNav.removeClass(STICKY_NAV_CLASS);
      });
    } else {
      mainNav.addClass(OPEN);
      // Scroll to our element

      $('html, body').animate({ scrollTop: scrollTo }, HALF_SECOND, function () {
        mainNav.removeClass(STICKY_NAV_CLASS);
      });
    }
  }

  /**
   * Toggle sub menu
   */
  function toggleSubmenu(that): void {
    // Clear sticky recalc interval if it's already running
    stopStickyRecalc();
    $body.trigger(STICKY_KIT_RECALC);

    const parentLi = that.closest('li');
    const submenu = $('> .sub-menu', parentLi);
    const submenuHeight = $('> ul', submenu).outerHeight();
    const siblings = that.parent('a').parent('li').siblings('li');

    // Set current height to prevent jumpy animations
    submenu.css('height', submenu.outerHeight());

    // Start sticky recalc interval
    startStickyRecalc();

    // Close open siblings
    siblings.each(function (): void {
      if ($(this).hasClass(OPEN)) {
        const targetSub = $('> .sub-menu', $(this));
        targetSub.css('height', targetSub.outerHeight());

        $(this).removeClass(OPEN);
        targetSub.stop().animate({ height: 0 }, HALF_SECOND, function () {
          $(this).removeAttr('style');
          $body.trigger(STICKY_KIT_RECALC);
        });
      }
    });

    // Close or open clicked
    if (parentLi.hasClass(OPEN)) {
      // Close submenu
      parentLi.removeClass(OPEN);

      submenu.stop().animate({ height: 0 }, HALF_SECOND, function () {
        $(this).removeAttr('style');
        // Clear sticky recalc interval
        stopStickyRecalc();
        $body.trigger(STICKY_KIT_RECALC);
      });
    } else {
      // Open submenu
      parentLi.addClass(OPEN);
      submenu.stop().animate({ height: submenuHeight }, HALF_SECOND, function () {
        $(this).removeAttr('style');
        // Clear sticky recalc interval
        stopStickyRecalc();
        $body.trigger(STICKY_KIT_RECALC);
      });
    }
    $body.trigger(STICKY_KIT_RECALC);
  }

  /**
   * Toggle nav search
   */
  function toggleNavSearch(): void {
    const $appSearch = $('#app-search');
    $appSearch.toggleClass(SHOW);
    if ($appSearch.hasClass(SHOW)) {
      const events = 'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd';
      $('#app-search .search-container').one(events, () => {
        $('#app-search .search-input input').trigger('focus');
        $('#app-search .search-container').off(events);
      });
    }
  }

  /**
   * Sticky sidebar
   */
  function stickySidebar(): void {
    // All sidebars with sticky class
    const $stickySidebar = $('.sidebar.sticky');

    // Check if any sticky sidebar exists
    if ($stickySidebar.length) {
      // Trigger a detach in case it is already initiated
      $stickySidebar.trigger('sticky_kit:detach');

      // Clear all styles from spacer element to make sure it doesn't get stuck with odd styles
      $('.sidebar-spacer').removeAttr('style');

      // Run only if the sidebar is still a sidebar by checking if it is floated to the left
      $stickySidebar.each(function eachSidebar() {
        const $self = $(this);
        if ($self.css('float') === 'left') {
          $self.stick_in_parent({
            offset_top: Math.round($('#app-navigation-container').outerHeight()) + 30,
            parent: '.page-content',
            spacer: $('.sidebar-spacer'),
          });
        }
      });
      $body.trigger(STICKY_KIT_RECALC);
    }
  }

  /**
   * Scroll to top of the page function
   */
  function scrollTop(): void {
    const scrollTo = $('#app-header').height();
    $('html, body').animate({ scrollTop: scrollTo }, HALF_SECOND);
  }

  /**
   * Give instant filter results in exposed filters.
   * Submit button hidden by CSS in exposed-filters.css to avoid it being visible on slow page loads
   */
  Drupal.behaviors.instantFilterResults = {
    attach: function attach(context): void {
      let currentVal = null;
      let timeoutId = null;
      const $filterSubmit = $('.views-exposed-form input:submit', context);
      const $textInput = $('.views-exposed-form input:text', context);
      const $notTextInput = $('.views-exposed-form input:not(:text), .views-exposed-form select', context);

      // Only run if filters exist
      if ($filterSubmit.length) {
        // Trigger submit on change for all input fields except text
        $notTextInput.on('change', function change(): void {
          $filterSubmit.trigger(CLICK);
        });

        // Save value on keydown for text inputs so we can detect change
        $textInput.on('keydown', function keyDown(): void {
          currentVal = $(this).val();
        });

        // Check for change and that input is alphabetic or backspace
        $textInput.on('keyup', function keyUp(e): void {
          if (currentVal !== $(this).val() && (ALPHA_PATTERN.test(e.key) || e.key === 'Backspace')) {
            // Clear previous interval to avoid multiple clicks
            clearTimeout(timeoutId);
            // Set interval to delay search result
            timeoutId = setTimeout((): void => {
              $filterSubmit.trigger(CLICK);
            }, HALF_SECOND);
          }
        });
      }
    },
  };

  /**
   * Trigger sticky recalc on click with a minor delay
   */
  Drupal.behaviors.updateSidebarsOnClick = {
    attach: function attach(): void {
      // Update sidebars on click
      $body.on(CLICK, function onClick() {
        requestAnimationFrame((): void => {
          $body.trigger(STICKY_KIT_RECALC);
        });
      });
    },
  };

  function doReload(): void {
    /**
     * Trigger primary nav check for mobile or normal menu on page load
     */
    menuModeSwitch();

    /**
     * Initiate prep nav on page load
     */
    prepNav();

    /**
     * Trigger stickyNav on page load
     */
    stickyNav();

    /**
     * Trigger primary nav hover
     */
    primaryNavHover();

    /**
     * Trigger sticky sidebar on page load
     */
    stickySidebar();
  }

  // PAGE LOAD
  $(function onReady() {
    $('.sidebar-menu li a.jdd-open').parent().addClass(OPEN);
    doReload();
    /**
     * Toggle primary mobile nav on click
     */
    $('#mobile-nav-toggle').on(CLICK, function onClick() {
      toggleMobileNav();
    });

    /**
     * Toggle submenu on click
     */
    $('.toggle-submenu').on(CLICK, function onClick(event) {
      event.preventDefault();
      toggleSubmenu($(this));
    });

    /**
     * Toggle show/hide search form on click
     */
    $('#app-search .toggle-search').on(CLICK, function onClick() {
      toggleNavSearch();
    });

    /**
     * Submit search form on click
     */
    $('#app-search .submit-search').on(CLICK, function onClick() {
      $('#app-search .search-input form').trigger('submit');
    });

    /**
     * Trigger hbToggle on click
     */
    $('.hb-toggle-trigger').on(CLICK, function onClick() {
      hbToggle($(this));
    });

    /**
     * Trigger scrollTop on click
     */
    $('.scroll-top').on(CLICK, function onClick(e) {
      e.preventDefault();
      scrollTop();
    });

    /**
     * Initiates Magnific Popup for all inline images on a page
     */
    $('.wysiwyg-content img').each(function eachWysiwygImageItem(): void {
      // Each image added through WYSIWYG editor
      const $self = $(this);
      const $parent = $self.parent();
      if (!$parent.hasClass('no-popup') && !$parent.is('a')) {
        // Ignore images marked to not have a popup and is not linked
        $self.addClass('mfp-item');
        initMainImagePopup($self, $self.attr('src'));
      }
    });

    /**
     * Initiates Magnific Popup for node main image
     */
    const $nodeMainImage = $('.node-main-image');
    initMainImagePopup($nodeMainImage, $nodeMainImage.data('src'));

    /**
     * Trigger sticky recalc when everything is fully loaded to make sure nothing has changed
     */
    $(window).on('load', function documentLoaded() {
      $body.trigger(STICKY_KIT_RECALC);
    });
  });

  let scrollTracker;
  let isScrolled = false;
  function trackScroll(): void {
    if (scrollTracker) {
      cancelAnimationFrame(scrollTracker);
    }
    scrollTracker = requestAnimationFrame(() => {
      if (isScrolled) {
        isScrolled = false;
        stickyNav();
      }
      trackScroll();
    });
  }

  trackScroll();

  window.addEventListener('scroll', () => {
    isScrolled = true;
  });

  // WINDOW RESIZE
  let resizeTrackerId;
  let isResized = false;
  function trackResize(): void {
    if (resizeTrackerId) {
      cancelAnimationFrame(resizeTrackerId);
    }
    resizeTrackerId = requestAnimationFrame(() => {
      if (isResized) {
        isResized = false;
        doReload();
      }
      trackResize();
    });
  }

  trackResize();

  window.addEventListener('resize', () => {
    isResized = true;
  });
});
